import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "columns-visibility-menu flex flex-col relative" };
const _hoisted_2 = { class: "columns-button-text flex items-center text-foreground font-medium" };
const _hoisted_3 = { class: "column-reset-section sticky top-0 z-10 bg-background" };
const _hoisted_4 = { class: "column-list-container w-full max-h-[300px] overflow-y-auto" };
const _hoisted_5 = ["onMouseenter"];
const _hoisted_6 = ["textContent"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["EnMenu"], {
            ref: "menuComponent",
            absolute: "",
            "offset-y": "",
            align: "end",
            class: "p-1 z-2500 w-min"
        }, {
            trigger: _withCtx(() => [
                _createVNode($setup["EnButton"], {
                    ref: "button",
                    class: "columns-visibility-menu-button flex items-center justify-center relative",
                    size: "default",
                    tooltip: $setup.t('common.dataGrid.columnEdit'),
                    "tooltip-location": "bottom",
                    "static-id": $setup.buildIdForVisibilityMenu(),
                    onClick: $setup.handleClick
                }, {
                    prepend: _withCtx(() => [
                        _createVNode($setup["ColumnsIcon"])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString($setup.t('common.dataGrid.columnsButtonText')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["tooltip", "static-id"])
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode($setup["EnButton"], {
                            variant: "ghost",
                            class: "w-full h-auto justify-start gap-2 py-[0.4rem] px-[0.8rem]",
                            "static-id": "reset-columns-button",
                            onClick: $setup.showAllColumnsAndClose
                        }, {
                            prepend: _withCtx(() => [
                                _createVNode($setup["EyeIcon"], { size: 16 })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.columnShowAll')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        ($props.showRestoreDefaultViewButton)
                            ? (_openBlock(), _createBlock($setup["EnButton"], {
                                key: 0,
                                variant: "ghost",
                                class: "w-full h-auto justify-start gap-2 py-[0.4rem] px-[0.8rem]",
                                "static-id": $setup.buildIdForRestoreDefaultView(),
                                onClick: $setup.restoreDefaultViewAndClose
                            }, {
                                prepend: _withCtx(() => [
                                    _createVNode($setup["RestoreIcon"], { size: 16 })
                                ]),
                                default: _withCtx(() => [
                                    _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.columnRestoreDefaultView')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["static-id"]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createVNode($setup["MenuSeparator"]),
                    _createCommentVNode(" Scrollable Column List "),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode($setup["EnDraggableWrapper"], {
                            modelValue: $setup.draggableColumns,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.draggableColumns) = $event)),
                            animation: 150,
                            handle: ".column-drag-handle",
                            class: "column-list flex flex-col",
                            onUpdate: $setup.onColumnDragged
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draggableColumns, (column) => {
                                    return (_openBlock(), _createBlock($setup["EnItem"], {
                                        key: column.value,
                                        class: _normalizeClass(["p-0", $setup.isLastVisibleColumn(column) ? 'cursor-default' : 'cursor-pointer']),
                                        state: $setup.isLastVisibleColumn(column) ? 'disabled' : 'default',
                                        onClick: ($event) => ($setup.toggleColumn(column))
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["column-list-item flex w-full min-w-0 flex-row items-center gap-3 py-[0.3rem] px-[0.5rem] rounded-[0.3rem]", $setup.isLastVisibleColumn(column) ? 'bg-en-blue-100 opacity-60' : 'hover:bg-en-blue-100']),
                                                onMouseenter: ($event) => ($setup.checkTitleIsClipped($event, column))
                                            }, [
                                                _createVNode($setup["EnCheckboxButton"], {
                                                    class: "column-switch shrink-0",
                                                    "model-value": !column.isHidden,
                                                    id: $setup.buildId(column),
                                                    disabled: $setup.isLastVisibleColumn(column),
                                                    color: "primary",
                                                    density: "compact",
                                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                                                    "onUpdate:modelValue": ($event) => ($setup.toggleColumn(column))
                                                }, null, 8 /* PROPS */, ["model-value", "id", "disabled", "onUpdate:modelValue"]),
                                                _createCommentVNode(" A long title would widen the menu, so it is clipped and the tooltip carries all of it. "),
                                                _createVNode($setup["EnTooltip"], {
                                                    text: column.title,
                                                    disabled: !$setup.clippedTitles[column.value]
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                            class: "column-title w-0 grow min-w-0 truncate",
                                                            textContent: _toDisplayString(column.title)
                                                        }, null, 8 /* PROPS */, _hoisted_6)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled"]),
                                                _createVNode($setup["EnTooltip"], {
                                                    text: $setup.t('common.dataGrid.columnReorder')
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("span", {
                                                            class: "column-drag-handle flex shrink-0 items-center cursor-grab opacity-40 hover:opacity-100",
                                                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                                                        }, [
                                                            _createVNode($setup["GripVertical"], { size: 16 })
                                                        ])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["text"])
                                            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "state", "onClick"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "onUpdate"])
                    ])
                ])
            ]),
            _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */)
    ]));
}
